<script setup lang="ts">
  import { type ButtonHTMLAttributes } from 'vue'
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    to?: RouteLocationRaw,
    loading?: boolean,
    disabled?: boolean,
    target?: '_blank' | '_self' | '_parent' | '_top', // https://www.w3schools.com/tags/att_a_target.asp
    type?: ButtonHTMLAttributes['type'],
    href?: string,
  }>()
  // disabled / loading show button, else show link
</script>

<template>
  <router-link
    v-if="!disabled && !loading && to"
    :target="target"
    :to="to">
    <slot></slot>
  </router-link>
  <a
    v-else-if="!disabled && !loading && href"
    :href="href"
    :target="href ? '_blank' : undefined">
    <slot></slot>
  </a>
  <button
    v-else
    class="disabled:cursor-not-allowed"
    :type="type ?? 'button'"
    :disabled="disabled || loading">
    <slot></slot>
    <app-loading-dot v-if="loading" />
  </button>
</template>

<style scoped lang="postcss">
</style>
